import React from 'react';
import ProductDetail from '../components/Products/ProductDetail';

const ProductsPage = () => {
	return (
		<>
			<ProductDetail />
		</>
	);
};

export default ProductsPage;
